import {Property} from './Property';

export class Style {
  public id: number;
  public name: string;
  public properties: Property[];
}
